import React, { useState } from 'react';
import { StarRating } from './StarRating';
import { LiaTimesSolid } from 'react-icons/lia';
import axios from 'axios';
import { toast } from 'react-toastify';
// import RatingForm from './RatingForm';
import { LoadingMode } from '../Components/LoadingMode';
import { windowReload } from '../utils';

export const RateModal = ({ rateData }) => {
  const [inputs, setInputs] = useState({ review: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [rating, setRating] = useState(0);

  // const [isSubmittingRating, setIsSubmittingRating] = useState(false);
  const stateObject = {
    rating,
    setRating,
  };
  const { handleHideRating, userToken, viewData, handleOpenandCloseModal } =
    rateData;
  const handleChange = (event) => {
    setInputs((input) => ({
      ...input,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmitRating = async (e) => {
    e.preventDefault();

    const ratingData = {
      rated_user_id: viewData.user.id,
      star: rating,
      review: inputs.review,
      cx_id: viewData.id,
    };
    // setIsSubmittingRating(true);
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/rating/store`,
        ratingData,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('rated', response);
      toast.success('Rating Submitted successfully !', {
        position: toast.POSITION.TOP_RIGHT,
      });
      handleHideRating();
      // setIsSubmittingRating(false);
      windowReload();
    } catch (error) {
      console.log(error, 'error in rating');
    } finally {
      setIsLoading(false);
    }
  };

  // console.log(ratingData);

  // useEffect(() => {
  //   if (isSubmittingRating) {
  //     const acceptOffer = async () => {
  //       try {
  //         const response = await axios.post(
  //           `${process.env.REACT_APP_BASE_URL}/rating/store`,
  //           ratingData,
  //           { headers: { Authorization: `Bearer ${userToken}` } }
  //         );
  //         console.log('rated', response);
  //         toast.success('Rating Submitted successfully !', {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //         handleHideRating();
  //         setIsLoading(false);
  //         setIsSubmittingRating(false);
  //       } catch (error) {
  //         console.log(error, 'error in rating');
  //         setIsLoading(false);
  //       }
  //     };
  //     acceptOffer();
  //   }
  // }, [userToken, isSubmittingRating]);

  return (
    <section className='fixed bg-p-bk/50 w-screen h-screen top-0 left-0 z-100'>
      <div className='w-full md:w-[385px] bg-p-wh rounded-lg shadow-xl py-8 flex flex-col gap-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
        <div className='flex flex-row justify-between items-center px-8 border-b-hf pb-3'>
          <h2 className='font-semibold text-xl'>Rate User</h2>
          <span
            className=' flex items-center justify-center w-8 h-8 rounded-full text-xl  text-s-bk text-right cursor-pointer hover:text-p-bk/5'
            onClick={() => handleOpenandCloseModal('close')}
          >
            <LiaTimesSolid />
          </span>
        </div>
        <form className='px-8 space-y-6' onSubmit={handleSubmitRating}>
          <p className='-mb-6'>Rate</p>
          <StarRating data={stateObject} />
          <div className='w-full '>
            <label>FeedBack</label>
            <input
              type='text'
              name='review'
              value={inputs.review}
              className='h-12 w-full border-hf rounded-md mt-2 px-2'
              onChange={handleChange}
              required
            />
          </div>
          <button
            type='submit'
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 py-2.5 w-full h-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative'
            disabled={isLoading}
          >
            Rate user
            {isLoading && <LoadingMode />}
          </button>{' '}
        </form>
      </div>
      {/* <RatingForm
        content={{
          stateObject,
          isLoading,
          setIsLoading,
          inputs,
          setInputs,
          handleOpenandCloseModal,
        }}
      /> */}
    </section>
  );
};
